// ============================================================================
// BonBoZ: kho ảnh marketing — phần dùng chung giữa bảng chọn ảnh (KhoAnh.vue),
// mẫu trả lời kèm ảnh (MauTraLoi.vue) và gõ "/" trong khung soạn (ReplyBox.vue).
//
// Cả ba cần đúng một việc: từ ảnh trong kho -> tệp trong khay chờ gửi của khung
// soạn tin. Viết ba lần thì lần sau sửa một chỗ quên chỗ kia, nên nó nằm ở đây.
//
// KHÔNG CÒN BỘ ĐỆM CẢ KHO: kho phân trang, không nạp "hết ảnh" được nữa. Mẫu trả lời được server trả kèm `anh` (id, tên, URL) —
// xem `CannedResponsesController#kem_anh` — nên gửi từ trang nào cũng đủ ảnh.
// ============================================================================

/**
 * Tải byte ảnh về rồi đẩy vào khung soạn tin như tệp người dùng tự chọn.
 *
 * KHÔNG gửi ngay: người trực phải thấy ảnh trước, gõ lời nhắn, rồi tự bấm gửi.
 * Một cú bấm nhầm là một tin thật tới khách mà Meta không cho thu hồi.
 *
 * Trả về số ảnh chèn được — chỗ gọi báo lỗi nếu ít hơn số ảnh yêu cầu.
 */
export const chenAnhVaoKhay = async (danhSach, onFileUpload) => {
  const coUrl = (danhSach || []).filter(a => a?.url);
  // Tuan tu chu khong Promise.all: moi anh la mot lan upload len server, ban
  // het mot luot thi khay cho co the nhan anh sai thu tu.
  for (let i = 0; i < coUrl.length; i += 1) {
    const anh = coUrl[i];
    // eslint-disable-next-line no-await-in-loop
    const blob = await (await fetch(anh.url)).blob();
    const duoi = blob.type.split('/')[1] || 'png';
    const tep = new File([blob], `${anh.ten}.${duoi}`, {
      type: blob.type || 'image/png',
    });
    // `bonbozAnhId` đi xuyên qua fileUploadMixin tới ReplyBox#attachFile, để sau
    // này gỡ đúng tấm khỏi khay khi người trực bỏ chọn nó trong kho.
    onFileUpload({
      name: tep.name,
      type: tep.type,
      size: tep.size,
      file: tep,
      bonbozAnhId: anh.id,
    });
  }
  return coUrl.length;
};

/**
 * Chèn ảnh của một mẫu trả lời (bản ghi server trả về).
 *
 * Trả về số ảnh THIẾU: `anh_ids` còn id mà `anh` không có (ảnh đã bị xoá khỏi
 * kho) — chỗ gọi báo cho người trực, mẫu vẫn dùng được.
 */
export const chenAnhCuaMau = async (mau, onFileUpload) => {
  const can = mau?.anh_ids?.length || 0;
  if (!can) return 0;
  return can - (await chenAnhVaoKhay(mau.anh, onFileUpload));
};
